import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceFingerprintService {
  private static readonly KEY = 'sidly_device_id';

  get(): string {
    let id = window.localStorage.getItem(DeviceFingerprintService.KEY);
    if (!id) {
      id = this.generate();
      window.localStorage.setItem(DeviceFingerprintService.KEY, id);
    }
    return id;
  }

  reset(): string {
    window.localStorage.removeItem(DeviceFingerprintService.KEY);
    return this.get();
  }

  private generate(): string {
    const cryptoObj: Crypto | undefined = (window as any).crypto || (window as any).msCrypto;
    if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
      const buf = new Uint8Array(16);
      cryptoObj.getRandomValues(buf);
      buf[6] = (buf[6] & 0x0f) | 0x40;
      buf[8] = (buf[8] & 0x3f) | 0x80;
      const hex = Array.from(buf).map(b => b.toString(16).padStart(2, '0')).join('');
      return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
    }
    return 'fp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
}
